<template lang="pug">
  #appHeader
    .appHeader-line
    .d-flex.align-items-center.justify-content-center.p-3
      b-img.p-4(
        fluid,
        :src="'xxx'",
        alt="logo",
        :onerror="defaultLogo",
        v-if="headerType === 'logo'",
        @click="backHandler()"
        style='max-height: 93px;'
      )
      h4.mb-0(
        v-if="headerType === 'title'"
      ) {{ title }}
</template>

<script>

import defaultLogoUrl from '@/assets/images/logo/logo.png';

export default {
  name: 'appHeader',
  props: {
    hasBackTool: {
      type: Boolean,
      default: false
    },
    headerType: {
      type: String,
      default: 'logo'
    },
    title: {
      type: String,
      default: null
    },
    targetRouterName: {
      type: String,
      default: null
    },
    targetRouterParams: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      defaultLogo: `this.src="${defaultLogoUrl}"`
    };
  },
  methods: {
    backHandler() {
      const vm = this;
      if (vm.targetRouterName && vm.hasBackTool) {
        const targetInfo = {
          name: vm.targetRouterName,
          params: vm.targetRouterParams
        };
        if (!vm.targetRouterParams) {
          delete targetInfo.params;
        }
        vm.$router.push(targetInfo);
      } else {

      }
    }
  }
};
</script>
